<template>
<div class="flex-cont main-cont" style="height:100%;">
    <div class="common-header" style="height:65px;">
        <div class="center-cont clearfix">
            <div class="left logo-cont">
                <img src="../../assets/logo/main-logo.png" alt />
            </div>
            <el-menu class="left" :default-active="activeIndex" mode="horizontal" text-color="#fff" active-text-color="#0d8fe3">
                <el-menu-item index="0">
                    <a href="/main" class="link-css">首页</a>
                </el-menu-item>
                <el-submenu index="1">
                    <template slot="title">大湾区产业地图</template>
                    <el-menu-item index="1-1">
                        <a @click="GetCode($config.Cydt.systemCode,$config.Cydt.pageUrl+'/macrographydata')" class="small-link">宏观数据</a>
                    </el-menu-item>
                    <el-menu-item index="1-2">
                        <a @click="GetCode($config.Cydt.systemCode,$config.Cydt.pageUrl+'/datamap')" class="small-link">数据地图</a>
                    </el-menu-item>
                    <el-menu-item index="1-3">
                        <a @click="GetCode($config.Cydt.systemCode,$config.Cydt.pageUrl+'/heatmap')" class="small-link">热力图</a>
                    </el-menu-item>
                </el-submenu>
                <el-menu-item index="2">
                    <a @click="GetCode($config.Yqk.systemCode,$config.Yqk.pageUrl+'/gbaparkstore')" class="link-css">大湾区园区库</a>
                </el-menu-item>
                <el-menu-item index="3">
                    <a @click="GetCode($config.Dp.systemCode,$config.Dp.pageUrl+'/parkbigscreen')" class="link-css">园区大屏</a>
                </el-menu-item>
                <!-- <el-menu-item index="4">
                    <a href="http://localhost:8094" class="link-css">行业信息</a>
                </el-menu-item> -->

                 <el-menu-item index="4">
          <a href="https://zs.hezongshuju.com" target="_blank" class="link-css">招商智囊</a>
          </el-menu-item>

          <el-menu-item index="5">
            <a class="link-css">园区空间资管</a>
          </el-menu-item>
        </el-menu>
            </el-menu>
            <div class="right avatar-cont">
                <div class="btn-panel" v-if="!parkToken">
                    <button type="button" class="login" @click="selfLogin">登 录</button>
                    <!-- <button type="button" class="m-l-20 register" @click="register">注 册</button> -->
                </div>
                <el-dropdown trigger="click" v-else>
                    <span class="el-dropdown-link p-l-10 p-r-10">
                        <el-avatar :size="28" :src="userInfo.userIcon" class="m-r-5"></el-avatar>
                        {{userInfo.name}}
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>个人中心</el-dropdown-item>
                        <el-dropdown-item><span @click="del_User">退出登录</span></el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
    </div>
    <el-main style="margin-top:65px;" class="login-bg">
        <div class="center-cont-bg clearfix">
            <div class="toggle-title">
                <div class="item" :class="phoneLoginFlag?'active':''" @click="toggleLogin(1)">短信登录</div>
                <div class="item" :class="loginFlag?'active':''" @click="toggleLogin(2)">账号登录</div>
            </div>
            <div v-if="phoneLoginFlag" class="center-cont">
                <div class="form-cont">
                    <el-form ref="phoneLoginForm" status-icon :model="phoneLoginForm" :rules="rules" style="padding:0;">
                        <el-form-item prop="phone">
                            <el-input placeholder="请输入手机号" prefix-icon="iconfont icon-dianhua" v-model.number="phoneLoginForm.phone" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input placeholder="请输入验证码" prefix-icon="iconfont icon-yanzhengma2" v-model="phoneLoginForm.verificationCode" style="width:72%;"></el-input>
                            <el-button type="primary" :disabled="disabled=!show" class="vercode">
                                <span v-show="show" @click.stop="getVeriCode('phoneLoginForm',1)">获取验证码</span>
                                <span v-show="!show" class="count" style="color: #fff;">{{count}} s</span>
                            </el-button>
                        </el-form-item>
                        <el-row>
                            <el-button type="primary" @click="submitForm('phoneLoginForm',2)" class="m-t-10">登 录</el-button>
                        </el-row>
                        <el-row>
                            <!-- <el-button type="primary" plain @click="register()" class="m-t-20">注 册</el-button> -->
                        </el-row>
                        <!-- <el-row class="center grey">
                            还没有注册账号？
                        </el-row> -->
                    </el-form>
                </div>
            </div>
            <div v-if="loginFlag" class="center-cont">
                <div class="form-cont">
                    <el-form ref="loginForm" status-icon :model="loginForm" :rules="rules" style="padding:0;">
                        <el-form-item prop="loginName">
                            <el-input placeholder="请输入手机号" prefix-icon="iconfont icon-dianhua" v-model.number="loginForm.loginName" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item prop="passWord">
                            <el-input type="passWord" placeholder="请输入密码" prefix-icon="iconfont icon-mimasuo" v-model="loginForm.passWord"></el-input>
                        </el-form-item>
                        <div class="clearfix save-cont">
                            <div class="left">
                                <el-checkbox v-model="loginForm.saveme">记住我</el-checkbox>
                            </div>
                            <div class="right">
                                <el-link type="primary" :underline="false" @click="forgetPass">忘记密码？</el-link>
                            </div>
                        </div>
                        <el-row>
                            <el-button type="primary" @click="submitForm('loginForm',1)" class="m-t-30">登 录</el-button>
                        </el-row>
                    </el-form>
                </div>
            </div>
            <div v-if="forgetPassFlag" class="center-cont">
                <h5>忘记密码</h5>
                <div class="form-cont reset-cont">
                    <el-form ref="forgetForm" status-icon :model="forgetForm" :rules="rules" style="padding:0;">
                        <el-form-item prop="phone">
                            <el-input placeholder="请输入手机号" prefix-icon="iconfont icon-dianhua" v-model.number="forgetForm.phone" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input placeholder="请输入验证码" prefix-icon="iconfont icon-yanzhengma2" v-model="forgetForm.verificationCode" style="width:62%;"></el-input>
                            <el-button type="primary" :disabled="disabled=!show" class="vercode">
                                <span v-show="show" @click.stop="getVeriCode('forgetForm',3)">获取验证码</span>
                                <span v-show="!show" class="count" style="color: #fff;">{{count}} s</span>
                            </el-button>
                        </el-form-item>
                        <el-form-item prop="newpassWord">
                            <el-input type="passWord" placeholder="设置新密码" prefix-icon="iconfont icon-mimasuo" v-model="forgetForm.newpassWord"></el-input>
                        </el-form-item>
                        <el-form-item prop="confirmpassWord">
                            <el-input type="passWord" placeholder="请再次输入新密码" prefix-icon="iconfont icon-mimasuo" v-model="forgetForm.confirmpassWord"></el-input>
                        </el-form-item>
                        <!-- <input name="save" type="checkbox" id="saveBox" v-model="saveName" @click="isSave" :checked="this.saveName" />
              <label for="saveBox">记住用户名和密码</label>-->
                        <el-row class="m-t-10 m-b-10">
                            <el-link type="primary" :underline="false" @click="returnLogin">已有账号？返回登录</el-link>
                        </el-row>
                        <el-row>
                            <el-button type="primary" @click="updatePass('forgetForm')">完成</el-button>
                        </el-row>
                    </el-form>
                </div>
            </div>
            <div v-if="resetPassFlag" class="center-cont">
                <h5>设置密码</h5>
                <div class="form-cont">
                    <el-form ref="setForm" status-icon :model="setForm" :rules="rules" style="padding:0;">
                        <el-form-item prop="newpassWord">
                            <el-input type="passWord" placeholder="设置新密码" prefix-icon="iconfont icon-mimasuo" v-model="setForm.newpassWord"></el-input>
                        </el-form-item>
                        <el-form-item prop="confirmpassWord">
                            <el-input type="passWord" placeholder="请再次输入新密码" prefix-icon="iconfont icon-mimasuo" v-model="setForm.confirmpassWord"></el-input>
                        </el-form-item>
                        <el-row style="margin-top:42px;">
                            <el-button type="primary" @click="complete">完成</el-button>
                        </el-row>
                    </el-form>
                </div>
            </div>
        </div>
        <div class="login-footer">
            Copyright © 2020 深圳合纵数据科技有限公司&nbsp;&nbsp;<a target="_blank" href="https://beian.miit.gov.cn">粤ICP备19126409号-5</a>
        </div>
    </el-main>
</div>
</template>

<script>
import {
    getLocalStorageTime,
    getLocalStorage,
    JumpPage
} from "../../util/util";
import {
    mapMutations
} from "vuex";
import {
    userLogin,
    getVeriCode,
    verificationCode,
    forgetUserPwd,
    getMenuList,
    getRequestCode,
    PhoneuserLogin
} from "../../api/api.js";
import qs from "qs";
const TIME_COUNT = 60; //更改倒计时时间
export default {
    data() {
        var checkLoginname = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("手机号不能为空"));
            }
            console.log(typeof value);
            if (!Number.isInteger(value)) {
                return callback(new Error("请输入数字值"));
            } else {
                var re = /^1\d{10}$/;
                if (re.test(value)) {
                    return callback();
                } else {
                    return callback(new Error("请输入正确的手机号"));
                }
            }
            // setTimeout(() => {

            // }, 500);
        };
        var validatePass = (rule, value, callback) => {
            if (value === "") {
                return callback(new Error("请输入密码"));
            } else {
                if (this.loginForm.passWord !== "") {
                    // this.$refs.loginForm.validateField("passWord");
                }
                return callback();
            }
        };
        var checkPhone = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("手机号不能为空"));
            }
            // setTimeout(() => {

            // }, 500);
            console.log(!Number.isInteger(value));
            if (!Number.isInteger(value)) {
                return callback(new Error("请输入数字值"));
            } else {
                var re = /^1\d{10}$/;
                console.log(re.test(value));
                if (re.test(value)) {
                    return callback();
                } else {
                    return callback(new Error("请输入正确的手机号"));
                }
            }
        };
        var validatePass1 = (rule, value, callback) => {
            if (value === "") {
                return callback(new Error("请输入密码"));
            } else {
                if (this.forgetForm.newpassWord !== "") {
                    // this.$refs.setForm.validateField("newpassWord");
                }
                return callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === "") {
                return callback(new Error("请再次输入密码"));
            } else if (value !== this.forgetForm.newpassWord) {
                return callback(new Error("两次输入密码不一致!"));
            } else {
                return callback();
            }
        };
        return {
            loading: false,
            loginForm: {
                loginName: '',
                passWord: '',
                saveme: false
            },
            loginFormNew: {
                phone: "",
                verificationCode: ""
            },
            forgetForm: {
                phone: "",
                verificationCode: ""
            },
            setForm: {
                newpassWord: "",
                confirmpassWord: ""
            },
            phoneLoginForm: {
                phone: "",
                verificationCode: ""
            },
            saveName: false,
            loginFlag: false,
            phoneLoginFlag: true,
            forgetPassFlag: false,
            resetPassFlag: false,
            phone: "",
            verificationCode: "",
            newpassWord: "",
            confirmpassWord: "",
            //验证码按钮
            show: true, // 初始启用按钮
            count: "", // 初始化次数
            timer: null,
            focusState: false,
            rules: {
                loginName: [{
                    validator: checkLoginname,
                    trigger: "blur"
                }],
                passWord: [{
                    validator: validatePass,
                    trigger: "blur"
                }],
                phone: [{
                    validator: checkPhone,
                    trigger: "blur"
                }],
                newpassWord: [{
                    validator: validatePass1,
                    trigger: "blur"
                }],
                confirmpassWord: [{
                    validator: validatePass2,
                    trigger: "blur"
                }]
            },
            activeIndex: '100',
            parkToken: ''
        };
    },
    created() {
        getLocalStorageTime("parkTokenTime", this);
        var vals = getLocalStorage('parklogin');
        if (vals) {
            this.loginForm = JSON.parse(vals);
        }
        // this.$router.replace({path: '/login'});
    },
    watch: {
        timer: function (val) {
            // console.log(val);
            if (val == null) {
                this.show = true;
            }
        }
    },
    mounted() {
        this.parkToken = localStorage.getItem('parkToken');
        window.addEventListener('keydown',this.keyDown);
    },
    methods: {
        ...mapMutations([
            "parkLogin",
            "parkName",
            "parkType",
            "parkMenuid",
            "parkTokentime",
            "updateTokenStatus"
        ]),
        async submitForm(formName, type) {
            let _this = this;
            return new Promise((resolve, reject) => {
                //   if(_this.loginForm.saveme){
                //     localStorage.setItem('parklogin', JSON.stringify(_this.loginForm));
                //   }
                _this.$refs[formName].validate(valid => {
                    if (valid) {

                        if (type == 1) {
                            let params = {
                                Phone: _this.loginForm.loginName,
                                PassWord: _this.loginForm.passWord
                            };
                            _this.loading = true;
                            userLogin(params)
                                .then(function (response) {
                                    let res = response.data;
                                    _this.loading = false;
                                    if (res.code == 1) {
                                        // _this.getMenu();
                                        // 获取到当前时间,转换成JSON字符串序列
                                        let curtime = JSON.stringify(new Date().getTime());
                                        // 将用户token保存到vuex中,将当前时间保存
                                        _this.parkLogin({
                                            parkToken: res.data.loginToken
                                        });
                                        _this.parkTokentime({
                                            parkTokenTime: curtime
                                        });
                                        _this.parkName({
                                            parkusername: res.data.name
                                        });
                                        _this.parkType({
                                            parktype: res.data.type
                                        });
                                        _this.parkMenuid({
                                            parkmenuid: res.data.menuId
                                        });
                                        //_this.commonTipsSuccess("登录成功~");
                                        JumpPage('index', _this);
                                        _this.updateTokenStatus(true);
                                    } else {
                                        _this.commonTipsError(res.result);
                                    }

                                })
                                .catch(function (error) {
                                    console.log(error);
                                    _this.loading = false;
                                });
                        }

                        if (type == 2) {
                            let params = {
                                Phone: _this.phoneLoginForm.phone,
                                Code: _this.phoneLoginForm.verificationCode,
                                CodeType: 1
                            };
                            _this.loading = true;
                            PhoneuserLogin(params)
                                .then(function (response) {
                                    let res = response.data;
                                    _this.loading = false;
                                    if (res.code == 1) {
                                        // _this.getMenu();
                                        // 获取到当前时间,转换成JSON字符串序列
                                        let curtime = JSON.stringify(new Date().getTime());
                                        // 将用户token保存到vuex中,将当前时间保存
                                        _this.parkLogin({
                                            parkToken: res.data.loginToken
                                        });
                                        _this.parkTokentime({
                                            parkTokenTime: curtime
                                        });
                                        _this.parkName({
                                            parkusername: res.data.name
                                        });
                                        _this.parkType({
                                            parktype: res.data.type
                                        });
                                        _this.parkMenuid({
                                            parkmenuid: res.data.menuId
                                        });
                                        //_this.commonTipsSuccess("登录成功~");
                                        JumpPage('index', _this);
                                        _this.updateTokenStatus(true);
                                    } else {
                                        _this.commonTipsError(res.result);
                                    }

                                })
                                .catch(function (error) {
                                    console.log(error);
                                    _this.loading = false;
                                });
                        }
                    }
                });

            });
        },
        forgetPass: function () {
            this.loginFlag = false;
            this.forgetPassFlag = true;
        },
        returnLogin: function () {
            (this.phone = ""), (this.verificationCode = ""), (this.loginFlag = true);
            this.forgetPassFlag = false;
        },
        nextStep: function () {
            this.validverificationCode("forgetForm");
        },
        complete: function () {
            this.updatePass("setForm");
        },
        send(formName) {
            if (!this.timer) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.count = TIME_COUNT;
                        this.show = false;
                        this.timer = setInterval(() => {
                            if (this.count > 0 && this.count <= TIME_COUNT) {
                                this.count--;
                            } else {
                                this.show = true;
                                clearInterval(this.timer); // 清除定时器
                                this.timer = null;
                            }
                        }, 1000);
                    }
                });
            }
        },
        sendLogin(isValid) {
            if (!this.timer) {
                if (isValid) {
                    this.count = TIME_COUNT;
                    this.show = false;
                    this.timer = setInterval(() => {
                        if (this.count > 0 && this.count <= TIME_COUNT) {
                            this.count--;
                        } else {
                            this.show = true;
                            clearInterval(this.timer); // 清除定时器
                            this.timer = null;
                        }
                    }, 1000);
                } else {
                    this.$refs.loginFormNew.validate(valid => {
                        if (valid) {}
                    });
                }
            }
        },
        //获取验证码
        getVeriCode(formName, Type) {
            let _this = this;
            this.$refs[formName].validate(valid => {
                if (valid) {

                    var Phone = "";
                    if (Type == 1) {
                        Phone = _this.phoneLoginForm.phone;
                    }
                    if (Type == 3) {
                        Phone = _this.forgetForm.phone;
                    }
                    let params = {
                        Phone: Phone,
                        Type: Type
                    };
                    _this.loading = true;
                    getVeriCode(params)
                        .then(function (response) {
                            let res = response.data;
                            if (res.code == 1) {
                                _this.send(formName);
                                _this.commonTipsSuccess("短信发送成功，请注意查收");
                                _this.loading = false;
                            }
                            _this.loading = false;
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }
            });
        },
        //验证手机号和验证码是否一致
        validverificationCode(formName) {
            let _this = this;
            _this.$refs[formName].validate(valid => {
                if (valid) {
                    let params = {
                        Phone: _this.forgetForm.phone,
                        Code: _this.forgetForm.verificationCode
                    };
                    _this.loading = true;
                    verificationCode(params)
                        .then(function (response) {
                            let res = response.data;
                            if (res.code == 1) {
                                _this.commonTipsSuccess("验证成功,请修改密码~");
                                _this.forgetPassFlag = false;
                                _this.resetPassFlag = true;
                                _this.loading = false;
                            }
                            _this.loading = false;
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                } else {
                    _this.commonTipsError("提交失败");
                    return false;
                }
            });
        },
        //根据手机号，验证码修改密码
        updatePass(formName) {
            let _this = this;
            _this.$refs[formName].validate(valid => {
                if (valid) {
                    let params = {
                        Phone: _this.forgetForm.phone,
                        Code: _this.forgetForm.verificationCode,
                        PassWord: _this.forgetForm.newpassWord,
                        Type: 3
                    };
                    _this.loading = true;
                    forgetUserPwd(params)
                        .then(function (response) {
                            let res = response.data;
                            if (res.code == 1) {
                                _this.commonTipsSuccess("修改成功，请重新登录~");
                                _this.loading = false;
                                _this.forgetPassFlag = false;
                                _this.resetPassFlag = false;
                                _this.loginFlag = true;
                            }
                            _this.loading = false;
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                } else {
                    _this.commonTipsError(res.result);
                    return false;
                }
            });
        },
        getMenu() {
            var _this = this;
            let params = {};
            getMenuList(params)
                .then(function (response) {
                    console.log(response);
                    let res = response.data;
                    if (res.code == 1) {
                        _this.parkMenuid({
                            menuid: res.data
                        });
                        _this.loading = false;
                        //_this.commonTipsSuccess("登录成功~");
                        _this.$router.push({
                            name: "index"
                        });
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        GetCode(SysId, url) {
            let params = {
                SystemId: SysId,
            };
            var parkToken = localStorage.getItem("parkToken");
            if (!parkToken) {
                //直接跳转http
                window.location.href = url;
            } else {
                getRequestCode(params)
                    .then(function (response) {
                        let res = response.data;
                        if (res.code == 1) {
                            //console.log('');
                            window.location.href = url + "?code=" + res.data;
                        } else {
                            // if (res.code == -10) {
                            //   this.commonTipsError(res.result);
                            // } else {
                            this.commonTipsError("授权失败");
                            //}
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        },
        //点击登录按钮登录
        selfLogin() {
            this.loginDialog = true;
            this.form = {
                name: '',
                pwd: ''
            }
            //this.isLoading = true;
        },
        //注册
        register() {
            console.log("zhuce")
        },
        //切换登录方式
        toggleLogin(type) {
            if (type == 1) {
                let model = {
                    name: '',
                    pwd: '',
                    saveme: false
                };
                this.loginForm = model;
                this.phoneLoginFlag = true;
                this.loginFlag = false;
                this.forgetPassFlag = false;
                this.resetPassFlag = false;
            } else {
                let model = {
                    phone: "",
                    verificationCode: ""
                };
                this.phoneLoginForm = model;
                this.phoneLoginFlag = false;
                this.loginFlag = true;
                this.forgetPassFlag = false;
                this.resetPassFlag = false;
            }
        },
        keyDown(e) {
            //如果是回车则执行登录方法
            if (e.keyCode == 13) {
                if(this.loginFlag){
                    this.submitForm('loginForm',1)
                }
            }
        }
    }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue